import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../components/Navbar";
import Select from "react-select";
import { loading, tokens, select_style, alert, success, alert_url, toFixed, GET, POST, PUT, DELETE, format_date, float, DatePicker, getStorage, roundToTwo, calculate_water, cal_water_bill } from "../../components/CustomComponent.js";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import React, { Component } from "react";

const r_det = getStorage("role_detail")?.find((item) => item.name === "record-water-usage")?.role || [];
const view_r = r_det[0] === 1, create_r = r_det[1] === 1;

export default class RecordWaterUsage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_cost: false, status_cost: "", cost: "", update: false,
      data: { data: [] }, data_address: null, data_fullname: [],
      record_water_id: "", last_gauge_number: 0, current_gauge_number: 0, unit_used: 0, water_bill: 0,
      address_number: null, building: "", equipment_maintenance_fee: 0, common_expenses: 0, common_expenses_type: false,
      waste_cost: 0, cable_cost: 0, other_income: 0, add_debt: 0, reduce_debt: 0, fire_cost: 0,
      remark_add_debt: "", remark_reduce_debt: "", total_amount: 0, status_cable: false,
      full_name: "", room_size: 0, status_meter: 0, date_of_note: new Date(),
      setting_water_id: getStorage("water_id"), water_charge_start: 0, water_charge_end: 0, water_charge_price: 0,
      water_rate_list: [], payment_deadline: 0, common_expenses_text: 0, max_date: null,
      penalty_day_list: [], penalty_month_list: [], fire_month: ""
    };
  }

  async componentDidMount() {
    if (view_r) {
      loading(true);
      await this.GetSetting();
      await this.GetAll();
      await this.GetAddressNumberAll();
      loading(false);
    }
  }

  getTotal = (s = this.state) => ["water_bill", "equipment_maintenance_fee", "common_expenses", "waste_cost", "other_income", "add_debt", "fire_cost"]
    .reduce((sum, k) => sum + Number(s[k] || 0), 0) + (s.status_cable ? Number(s.cable_cost || 0) : 0) - Number(s.reduce_debt || 0);

  GetAddressNumberAll = async () => {
    let r = await GET(tokens, `v1/TH/record-water/address-list/${getStorage("project_id")}`, { now_month: Number(format_date(this.state.date_of_note, "mm")), now_year: Number(format_date(this.state.date_of_note, "yyyy", "en")) });
    if (r?.status) {
      let d = r.data.data.filter(i => !this.state.data?.data?.some(e => e.address_number === i.address_number))
                       .sort((a, b) => a.address_number.localeCompare(b.address_number, undefined, { numeric: true }));
      this.setState({ data_address: d });

      if (this.props.location.query.id) {
        this.setState({ update: true, record_water_id: this.props.location.query.id }, () => this.GetById(this.props.location.query.id));
      } else if (!d.length) {
        alert("warning", "แจ้งเตือน", "ไม่มีข้อมูลบ้านเลขที่ในเดือนนี้");
      } else {
        this.setState({ address_number: { value: d[0].address_number, label: `อาคาร ${d[0].building} ห้อง ${d[0].address_number}` }, building: d[0].building }, () => {
          this.GetAddressById();
          setTimeout(() => document.getElementById("current_gauge_number")?.focus(), 100);
        });
      }
    }
  };

  GetAddressById = async () => {
    let r = await GET(tokens, `v1/TH/record-water/address-number/detail/${getStorage("project_id")}`, { address_number: this.state.address_number?.value || "", date_of_note: format_date(this.state.date_of_note || new Date(), "yyyy-mm-dd", "en") });
    if (r?.status) {
      let d = r.data.data;
      this.setState({
        full_name: d.full_name, room_size: d.room_size, last_gauge_number: d.last_gauge_number, current_gauge_number: d.last_gauge_number,
        cable_cost: d.cable_cost, common_expenses: this.state.common_expenses_type ? roundToTwo(d.common_expenses * d.room_size) : d.common_expenses,
        equipment_maintenance_fee: d.equipment_maintenance_fee, waste_cost: d.waste_cost, unit_used: 0,
        status_meter: d.status_meter === 0 ? { value: 0, label: "" } : d.status_meter === 1 ? { value: 1, label: "ปกติ" } : { value: 2, label: "ตัดมิเตอร์" },
        water_bill: Number(this.state.water_charge_price), status_cable: d.status_cable || Number(d.cable_cost) !== 0,
        other_income: 0, add_debt: 0, reduce_debt: 0, fire_cost: 0, remark_add_debt: "", remark_reduce_debt: "",
      });
    }
  };

  GetAll = async () => {
    let r = await GET(tokens, `v1/TH/record-water-temp/filter-search/page/0/${getStorage("project_id")}`, { address_number: this.state.filter_address_number?.value || "" });
    if (r?.status) this.setState({ data: { ...r.data, data: r.data.data.reverse() } });
  };

  GetById = async (id) => {
    loading(true);
    let r = await GET(tokens, `v1/TH/record-water-temp/detail/${id}`, null);
    if (r?.status) {
      let d = r.data.data;
      this.setState({
        data_address: [...(this.state.data_address || []), { value: d.address_number, label: `อาคาร ${d.building} ห้อง ${d.address_number}` }],
        record_water_id: d.record_water_id, last_gauge_number: d.last_gauge_number, current_gauge_number: d.current_gauge_number,
        unit_used: d.unit_used, water_bill: d.water_bill, address_number: { value: d.address_number, label: `อาคาร ${d.building} ห้อง ${d.address_number}` },
        building: d.building, equipment_maintenance_fee: d.equipment_maintenance_fee, common_expenses: d.common_expenses, waste_cost: d.waste_cost, 
        cable_cost: d.cable_cost, other_income: d.other_income, add_debt: d.add_debt, reduce_debt: d.reduce_debt, fire_cost: d.fire_cost, 
        remark_add_debt: d.remark_add_debt, remark_reduce_debt: d.remark_reduce_debt, total_amount: d.total_amount, room_size: d.room_size, 
        status_meter: d.status_meter === 0 ? { value: 0, label: "" } : d.status_meter === 1 ? { value: 1, label: "ปกติ" } : { value: 2, label: "ตัดมิเตอร์" },
        date_of_note: d.datetime_create, status_cable: d.status_cable || Number(d.cable_cost) !== 0,
      }, () => {
        if (this.props.location.query.id) {
          let mx = new Date(d.datetime_create);
          mx.setDate(this.state.payment_deadline);
          this.setState({ max_date: format_date(mx, "yyyy-mm-dd", "en") });
        }
        this.cal_water();
        loading(false);
      });
    }
  };

  GetSetting = async () => {
    let r = await GET(tokens, `v1/TH/water-manage/detail/${this.state.setting_water_id}`, null);
    if (r?.status) {
      let d = r.data.data, date_of_note = new Date();
      if (d.payment_deadline) {
        let now = new Date();
        now.setDate(Number(d.payment_deadline));
        if (new Date() < now) now.setMonth(now.getMonth() - 1);
        date_of_note = now;
      }
      await new Promise((resolve) => {
        this.setState({
          water_charge_start: Number(d.water_charge.water_charge_start), water_charge_end: Number(d.water_charge.water_charge_end),
          water_charge_price: toFixed(Number(d.water_charge.water_charge_price)), water_rate_list: d.water_rate_list, water_calculate_type: Number(d.water_calculate_type) || 2,
          fire_cost: (d.fire_month && format_date(new Date(), "m") === d.fire_month) ? Number(d.fire_cost) : 0, fire_month: d.fire_month,
          common_expenses_type: d.common_expenses_type, common_expenses_text: d.common_expenses, payment_deadline: d.payment_deadline,
          penalty_day_list: d.penalty_day_list, penalty_month_list: d.penalty_month_list, date_of_note
        }, resolve);
      });
      if (!d.payment_close_time || !d.meter_cut_date || !d.penalty_day_list.length || !d.penalty_month_list.length) {
        alert_url("warning", "แจ้งเตือน", "ท่านยังไม่ทำการตั้งค่าอัตราค่าน้ำก่อนทำการเริ่มต้นใช้งานระบบ", "/manage-water");
      }
    }
  };

  cal_water = () => {
    this.setState({ water_bill: cal_water_bill(this.state.unit_used, this.state) });
  };

  processSave = async (isUpdate) => {
    if (Number(this.state.unit_used) < 0) return alert("warning", "แจ้งเตือน", "ไม่สามารถกรอกเลขมาตรในเดือนนี้น้อยกว่าเดือนก่อนได้");
    loading(true);
    let dt = isUpdate ? this.state.date_of_note : format_date(this.state.date_of_note, "yyyy-mm-dd hh:mm", "en");
    let data = { ...this.state, 
      address_number: this.state.address_number?.value || "", 
      total_amount: this.getTotal(), 
      cable_cost: this.state.status_cable ? Number(this.state.cable_cost) : 0, 
      datetime_create: dt,
      status_meter: this.state.status_meter?.value || this.state.status_meter || 0
    };
    if (!isUpdate) data.date_of_note = dt;

    let r = isUpdate ? await PUT(tokens, "v1/TH/record-water-temp/update", data) : await POST(tokens, `v1/TH/record-water-temp/create/${getStorage("project_id")}`, data);
    
    if (r?.status) {
      if (isUpdate) alert_url("success", "สำเร็จ", "บันทึกข้อมูลเรียบร้อยแล้ว", "/temp-record-water-usage");
      else {
        let dAddr = this.state.data_address.filter(i => i.address_number !== this.state.address_number?.value);
        this.setState({ data_address: dAddr, address_number: dAddr[0] ? { value: dAddr[0].address_number, label: `อาคาร ${dAddr[0].building} ห้อง ${dAddr[0].address_number}` } : null, building: dAddr[0]?.building || "" }, async () => {
          if (dAddr[0]) this.GetAddressById();
          loading(false);
          await success();
          document.getElementById("current_gauge_number")?.focus();
          this.GetAll();
        });
        return;
      }
    }
    loading(false);
  };

  Create = () => this.processSave(false);
  Update = () => this.processSave(true);

  UpdateCost = async () => {
    loading(true);
    let req = { data: this.state.data.data.map(i => {
      let u = { ...i };
      ['last_gauge_number', 'current_gauge_number', 'unit_used', 'water_bill', 'equipment_maintenance_fee', 'common_expenses', 'waste_cost', 'cable_cost', 'other_income', 'add_debt', 'reduce_debt', 'fire_cost'].forEach(k => u[k] = Number(i[k] || 0));
      if (this.state.status_cost) u[this.state.status_cost] = Number(this.state.cost);
      u.total_amount = this.getTotal(u);
      return u;
    })};
    let r = await PUT(tokens, "v1/TH/record-water-temp/update-all", req);
    if (r?.status) alert_url("success", "สำเร็จ", "บันทึกข้อมูลเรียบร้อยแล้ว", "/temp-record-water-usage");
    loading(false);
    this.setState({ modal_cost: false });
  };

  Delete = async (id) => {
    loading(true);
    let r = await DELETE(tokens, `v1/TH/record-water-temp/delete/${id}`, null);
    if (r?.status) {
      success();
      this.setState({
        last_gauge_number: 0, current_gauge_number: 0, unit_used: 0, water_bill: 0, address_number: null, building: "", equipment_maintenance_fee: 0, common_expenses: 0, waste_cost: 0, cable_cost: 0, other_income: 0, add_debt: 0, reduce_debt: 0, remark_add_debt: "", remark_reduce_debt: "", total_amount: 0, full_name: "", room_size: 0, status_meter: 0
      });
      await this.GetAddressNumberAll();
      this.GetAddressById();
      this.GetAll();
    }
    loading(false);
  };

  SendData = () => {
    Swal.fire({ title: "ยืนยันการบันทึกข้อมูล", text: "คุณต้องการบันทึกข้อมูลนี้ใช่หรือไม่?", icon: "warning", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "บันทึกข้อมูล", cancelButtonText: "ยกเลิก" }).then(async (res) => {
      if (res.isConfirmed) {
        loading(true);
        try {
          await Promise.all(this.state.data.data.map(async (i) => {
            let b = { ...i, status_cable: !!Number(i.cable_cost), date_of_note: format_date(i.datetime_create, "yyyy-mm-dd hh:mm", "en"), datetime_create: format_date(i.datetime_create, "yyyy-mm-dd hh:mm", "en") };
            b.total_amount = this.getTotal(b);
            let r = await POST(tokens, `v1/TH/record-water/create/${getStorage("project_id")}`, b);
            if (r.status) await DELETE(tokens, `v1/TH/record-water-temp/delete/${i.record_water_id}`, null);
            else throw new Error("API Failed");
          }));
          await calculate_water();
          alert_url("success", "สำเร็จ", "บันทึกข้อมูลเรียบร้อยแล้ว", "/temp-record-water-usage");
        } catch (e) { console.error(e); }
        loading(false);
      }
    });
  };

  hk = (nxt, prv) => (e) => {
    if (e.key === "Enter" || e.key === "ArrowRight") {
      if (!document.querySelector(".swal2-container") && nxt) (nxt === "SUBMIT") ? (this.state.update ? this.Update() : this.Create()) : document.getElementById(nxt)?.focus();
    } else if (e.key === "ArrowLeft" && prv) document.getElementById(prv)?.focus();
  };

  inp = (lbl, k, isNum = true, opts = {}) => (
    <div className="col-12 col-md-6 col-lg-3 mb-2">
      <label>{lbl} {opts.extra}</label>
      <input id={opts.id || k} className="form-control bg-contain border-0 mx-1 mb-2" placeholder="กรอกข้อมูล" value={this.state[k]} disabled={opts.dis}
        onChange={(e) => {
          let v = e.target.value;
          if (isNum && !float(v)) return;
          this.setState({ [k]: isNum && v === "" ? 0 : v }, opts.cb);
        }} onKeyUp={opts.ku} />
    </div>
  );

  render() {
    const s = this.state;
    const cHdrs = [ { id: "equipment_maintenance_fee", n: "ค่ารักษาอุปกรณ์น้ำ" }, { id: "common_expenses", n: "ค่าส่วนกลาง" }, { id: "waste_cost", n: "ค่าขยะ" }, { id: "cable_cost", n: "ค่าเคเบิล" }, { id: "fire_cost", n: "ค่าเบี้ยประกัน" }, { id: "other_income", n: "รายได้อื่นๆ" }, { id: "add_debt", n: "เพิ่มหนี้" }, { id: "reduce_debt", n: "ลดหนี้" } ];

    return (
      <div className="w-100 min-vh-100 fade-in">
        {s.loading && <div className="spinner-container"><div className="loading-spinner"></div></div>}
        <Navbar page1="หน้าหลัก" page2="บันทึกค่าใช้จ่าย" />
        <div className="body">
          <div className="p-3">
            <div className="d-flex justify-content-end"><button className="btn btn-outline-primary px-4 mx-1 mb-3" onClick={() => window.open(`${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/test-water`, "_blank", "noopener,noreferrer")}>ตรวจสูตรคำนวณค่าน้ำ</button><button className="btn btn-outline-primary px-4 mx-1 mb-3" onClick={() => window.location.href = "/water-usage-info"}>รายการทั้งหมด</button></div>
            <div className="w-100">
              <div className="card border-0 p-3 mb-3">
                <h4 className="mb-3"><b>บันทึกค่าใช้จ่าย เดือน{format_date(new Date(), "mmmm")} พ.ศ. {format_date(new Date(), "yyyy")}</b></h4>
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>บ้านเลขที่</label>
                    <Select className="form-control bg-contain border-0 w-100 select-search" styles={select_style} options={s.data_address?.map(i => ({ ...i, value: i.address_number, label: `อาคาร ${i.building} ห้อง ${i.address_number}` })) || []} onChange={(e) => this.setState({ address_number: e, building: e ? e.building : "" }, this.GetAddressById)} value={s.address_number} />
                  </div>
                  {this.inp("ชื่อ-นามสกุล", "full_name", false, { dis: true })}
                  {this.inp("ขนาดห้องที่อยู่อาศัย (ตรม.)", "room_size", false, { dis: true, cb: () => this.setState({ room_size: toFixed(s.room_size) }) })}
                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>สถานะมิเตอร์น้ำ</label>
                    <Select className="form-control bg-contain border-0 w-100 select-search" styles={select_style} options={[{ value: 0, label: "" }, { value: 1, label: "ปกติ" }, { value: 2, label: "ตัดมิเตอร์" }]} value={s.status_meter} isDisabled={true} />
                  </div>
                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>วันที่จด</label>
                    <DatePicker className="form-control bg-contain border-0 w-100" value={s.date_of_note} min={s.max_date ? format_date(new Date(new Date(s.max_date).setDate(new Date(s.max_date).getDate() - 1)), "yyyy-mm-dd", "en") : null} max={s.max_date || null} onChange={(e) => { this.setState({ date_of_note: e },() => {if (!this.props.location.query.id) this.GetAddressNumberAll()})  }} />
                  </div>
                  {this.inp("เลขมาตรเดือนก่อน", "last_gauge_number", true, { cb: () => this.setState({ unit_used: Number(this.state.current_gauge_number) - Number(this.state.last_gauge_number) }, this.cal_water), ku: this.hk("current_gauge_number") })}
                  {this.inp("เลขมาตรเดือนนี้", "current_gauge_number", true, { cb: () => this.setState({ unit_used: Number(this.state.current_gauge_number) - Number(this.state.last_gauge_number) }, this.cal_water), ku: this.hk("SUBMIT", "last_gauge_number") })}
                  {this.inp("จำนวนหน่วยที่ใช้", "unit_used", false, { dis: true })}
                  {this.inp("ค่าน้ำประปา", "water_bill")}
                  {this.inp("ค่ารักษาอุปกรณ์", "equipment_maintenance_fee")}
                  {this.inp(`ค่าใช้จ่ายส่วนกลาง ${s.common_expenses_type ? "( " + toFixed(s.common_expenses_text) + " บาท / ตรม. )" : ""}`, "common_expenses")}
                  {this.inp("ค่าขยะ", "waste_cost")}
                  {this.inp("ค่าเคเบิล", "cable_cost", true, { extra: s.cable_cost !== 0 && <input className="ml-2" type="checkbox" onChange={(e) => this.setState({ status_cable: e.target.checked })} checked={s.status_cable} />, cb: () => this.state.cable_cost !== 0 && !this.state.status_cable && this.setState({ cable_cost: 0 }) })}
                  {this.inp("ค่าเบี้ยประกัน", "fire_cost")}
                  {this.inp("รายได้อื่น", "other_income")}
                  {this.inp("เพิ่มหนี้", "add_debt")}
                  {this.inp("หมายเหตุเพิ่มหนี้", "remark_add_debt", false)}
                  {this.inp("ลดหนี้", "reduce_debt")}
                  {this.inp("หมายเหตุลดหนี้", "remark_reduce_debt", false)}
                </div>
                <div className="d-flex align-items-end justify-content-between">
                  <div><label>รวมเป็นเงิน</label><h4><b>฿{toFixed(this.getTotal())}</b></h4></div>
                  {create_r && <button className="btn btn-primary px-4" onClick={() => s.update ? this.Update() : this.Create()}>บันทึกข้อมูล</button>}
                </div>
                <small className="text-secondary">หมายเหตุ<br />- Enter หรือ ลูกศรขวา เพื่อไปยังช่องกรอกข้อมูลถัดไป<br />- ลูกศรซ้าย เพื่อกลับไปยังช่องกรอกข้อมูลก่อนหน้า</small>
              </div>
            </div>
          </div>
          
          <div className="p-3 pt-0">
            <div className="card border-0 p-3">
              <h4 className="mb-3"><b>รายการบันทึกค่าใช้จ่าย</b></h4>
              <div className="table-responsive">
                <table className="table table-borderless table-striped">
                  <thead>
                    <tr><th className="p-0" colSpan={6} rowSpan={2}></th><th className="text-center bg-light fw-bold" colSpan={8}>แก้ไขค่าใช้จ่ายทั้งหมด</th><th className="text-center" colSpan={2}></th></tr>
                    <tr>{cHdrs.map(c => <th key={c.id} className="text-center bg-light pt-0 pb-2"><button className="rounded-3 px-3 py-2 border-0 bg-warning text-dark text-10 text-nowrap" onClick={() => this.setState({ modal_cost: true, cost: "", status_cost: c.id })}>แก้ไข{c.n}</button></th>)}<th className="text-center" colSpan={2}></th></tr>
                    <tr className="bg-dark-blue text-white">
                      {["บ้านเลขที่", "วันที่บันทึก", "เลขมาตรเดือนนี้", "เลขมาตรก่อน", "จำนวนหน่วยที่ใช้", "ค่าน้ำประปา", "ค่ารักษาอุปกรณ์น้ำ", "ค่าส่วนกลาง", "ค่าขยะ", "ค่าเคเบิล", "ค่าเบี้ยประกัน", "รายได้อื่นๆ", "เพิ่มหนี้", "ลดหนี้", "รวมเป็นเงิน", "จัดการ"].map((h, i) => <th key={i} className={i === 1 ? "text-left text-nowrap" : "text-center text-nowrap"}>{h}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    {!s.data?.data?.length ? <tr><td colSpan={16} className="text-center">ไม่มีข้อมูล</td></tr> : s.data.data.map((i, idx) => (
                      <tr key={idx}>
                        <td className="text-center">{i.address_number || "-"}</td><td className="text-left">{i.datetime_create ? format_date(i.datetime_create) : "0"}</td>
                        {['current_gauge_number', 'last_gauge_number', 'unit_used'].map(k => <td key={k} className="text-right">{i[k] || "0"}</td>)}
                        {['water_bill', 'equipment_maintenance_fee', 'common_expenses', 'waste_cost', 'cable_cost', 'fire_cost', 'other_income', 'add_debt', 'reduce_debt', 'total_amount'].map(k => <td key={k} className="text-right">{toFixed(i[k])}</td>)}
                        <td className="text-center">
                          <div className="d-flex justify-content-center">
                            <label className="wpx-24 hpx-24 bg-primary-light rounded-1 d-flex align-items-center justify-content-center mr-2 icon text-primary pointer" onClick={() => window.location.href = "/temp-record-water-usage?id=" + i.record_water_id}>{"\uf304"}</label>
                            <label className="wpx-24 hpx-24 bg-danger-light rounded-1 d-flex align-items-center justify-content-center mr-2 icon text-danger pointer" onClick={() => Swal.fire({ icon: "warning", title: "ยืนยันการลบข้อมูล", text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่", showCancelButton: true, cancelButtonColor: "#d33", confirmButtonText: "ลบข้อมูล", cancelButtonText: "ยกเลิก" }).then((res) => { if (res.isConfirmed) this.Delete(i.record_water_id); })}>{"\uf1f8"}</label>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-end">{create_r && <button className="btn btn-primary px-5" onClick={this.SendData}>ส่งข้อมูลค่าใช้จ่าย</button>}</div>
            </div>
          </div>
        </div>

        <Modal show={s.modal_cost} onHide={() => this.setState({ modal_cost: false })}>
          <Modal.Header><Modal.Title><b>แก้ไขค่าใช้จ่าย</b></Modal.Title></Modal.Header>
          <Modal.Body>
            <div className="w-100 d-flex align-items-center mb-3">
              <label className="wpx-140">{cHdrs.find(c => c.id === s.status_cost)?.n || ""} :</label>
              <input className="form-control border-0 bg-contain" type="text" placeholder="กรอกข้อมูล" onChange={(e) => float(e.target.value) && this.setState({ cost: e.target.value })} value={s.cost} />
            </div>
            <div className="w-100 d-flex">
              <div className="w-50 p-1"><button className="btn btn-outline-primary w-100" onClick={() => this.setState({ modal_cost: false })}>ยกเลิก</button></div>
              <div className="w-50 p-1"><button className="btn btn-primary w-100" onClick={this.UpdateCost}>บันทึก</button></div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}